module.exports = __webpack_public_path__ + "img/icon_map_37_off_100.e74be8ec.png";